import SectionHeading from './SectionHeading';
import { siteInfo } from '@/mocks/siteInfo';

export default function OverviewSection() {
  return (
    <section id="overview" className="scroll-mt-24 bg-background-50 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="Overview"
          title="作品概览：先弄清楚它到底是一部什么作品"
          desc={siteInfo.summary}
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {siteInfo.facts.map((fact) => (
            <div
              key={fact.label}
              className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-4 md:p-5"
            >
              <span className="flex h-11 w-11 flex-none items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${fact.icon} text-xl`}></i>
              </span>
              <div>
                <p className="font-label text-xs uppercase tracking-wider text-foreground-500">{fact.label}</p>
                <p className="mt-1 font-heading text-base font-semibold text-foreground-950">{fact.value}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 flex items-start gap-3 rounded-lg border border-secondary-200 bg-secondary-50 p-4 md:p-5">
          <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
            <i className="ri-information-line"></i>
          </span>
          <p className="text-xs leading-relaxed text-secondary-900 md:text-sm">{siteInfo.notice}</p>
        </div>
      </div>
    </section>
  );
}